/* SessionDetailsList.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4bt5LAnQyn%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2WAcuGnQyn%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbvLZJ%7Bdisplay%3Ablock%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4ouGXIdnbC%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1EqgXlN91d%7Bmax-width%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39HuIbz8Lp%7Btext-overflow%3Aellipsis%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ANEUSLRg7%7Bwhite-space%3Anowrap%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0LQT5E2ADO%7Bpadding-inline-start%3Avar(--ds-space-100%2C8px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._03SyCP2ADO%7Bpadding-inline-end%3Avar(--ds-space-100%2C8px)%7D");
import React, { Children, Fragment, isValidElement, type ReactNode } from 'react';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';
const styles = {
  container: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _4ouGXIdnbC _1EqgXlN91d _39HuIbz8Lp _1ANEUSLRg7",
  separator: "_0LQT5E2ADO _03SyCP2ADO"
};
export type SessionDetailsListProps = {
  children: ReactNode;
  separator?: string;
  testId?: string;
};

/** A single line of session details that truncates as a whole at the trailing edge. */
export const SessionDetailsList = ({
  children,
  separator = '·',
  testId
}: SessionDetailsListProps): React.JSX.Element | null => {
  const details = Children.toArray(children).filter(isValidElement);
  if (details.length === 0) {
    return null;
  }
  return <Text as="span" size="small" color="color.text.subtlest">
			<Box as="span" xcss={styles.container} testId={testId}>
				{details.map((detail, index) => <Fragment key={detail.key}>
						{index > 0 && separator ? <Box as="span" xcss={styles.separator}>
								{separator}
							</Box> : null}
						{detail}
					</Fragment>)}
			</Box>
		</Text>;
};